var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "empty-notifications d-flex flex-column align-items-center mt-3",
    },
    [
      _c("i", {
        staticClass: "fa fa-bell-o",
        attrs: { "aria-hidden": "true" },
      }),
      _vm._v(" "),
      _c("p", { staticClass: "text-light-gray w-50 mt-3" }, [
        _vm._v("\n    " + _vm._s(_vm.computedText) + "\n  "),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }